module.exports = __webpack_public_path__ + "img/hero_s@2x.bb4af327.webp";